import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";

/**
 * Hook to detect mobile screen size
 * Listens to window resize events and updates state
 */
export function useMobileDetection() {
  const $ = _c(2);
  const [isMobile, setIsMobile] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const checkIfMobile = () => {
        setIsMobile(window.innerWidth < 768);
      };
      checkIfMobile();
      window.addEventListener("resize", checkIfMobile);
      return () => window.removeEventListener("resize", checkIfMobile);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isMobile;
}